import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Theme } from '@recruitee/theme';
import { tokenToCssVar } from '@recruitee/utils';

import { IconName } from '../../icons-container/icons.type';
import { IconToken } from '../icon/directives/icon-color.directive';
import { IconComponent, IconSize } from '../icon/icon.component';

export type BackgroundColors<T extends keyof Theme = keyof Theme> = T extends
  | `colorBg${string}`
  | `background${string}`
  ? T
  : never;

export type ContainerSize = 'medium' | 'large' | 'large-x' | 'large-xx';

@Component({
  selector: 'rt-icon-container',
  imports: [IconComponent],
  templateUrl: './icon-container.component.html',
  styleUrl: './icon-container.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.background]': 'this.backgroundCssVar()',
    '[class]':
      '["shape-" + this.shape(), "size-" + this.size(), "container-size-" + this.containerSize() || this.size()]',
  },
})
export class IconContainerComponent {
  public name = input.required<IconName>();
  public color = input.required<IconToken>();
  public background = input.required<BackgroundColors>();
  public size = input<IconSize>('medium');
  public containerSize = input<ContainerSize>('medium');
  public shape = input<'circle' | 'squircle'>('squircle');

  public backgroundCssVar = computed(() => tokenToCssVar(this.background()));
}
